<template>
  <div>
    <DialogBottomSheet
      :is-visible="isDialogOpened"
      :width="isMobile ? undefined : 375"
      content-class="rounded-0"
      @input="handleInput"
      @dialog-bottom-sheet:change-visible="closeDialog"
    >
      <v-card
        tile
        class="pt-6 px-4 pb-4"
      >
        <v-form @submit.prevent="handleSubmit">
          <div class="text-h6 mb-4">
            {{ t('Возраст пациента', options) }}
          </div>
          <FieldAge
            v-model="filtersStore.unsavedFilters"
            class="mb-4"
            autofocus
          />
        </v-form>
        <BtnShowDoctors
          v-model="isActiveButton"
          :active="isDialogOpened"
          @click:close="closeDialog"
          @click:submit="applyFilter"
        />
      </v-card>
    </DialogBottomSheet>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import I18NextVue from 'i18next'
import { debounce, dispatchCustomEventGlobally } from 'www/utils'
import DialogBottomSheet from 'www/vue_components/common/core/DialogBottomSheet.vue'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import updateDoctorListPage from 'www/vue_components/common/TheFilters/doctors/functions/updateDoctorListPage'
import BtnShowDoctors from 'www/vue_components/common/TheFilters/doctors/components/BtnShowDoctors/BtnShowDoctors.vue'
import FieldAge from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/FieldAge/FieldAge.vue'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('PatientAgeFilters')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const isActiveButton = ref(false)
const isMobile = window.MOBILE_VERSION

const patientAgeLabel = computed(() => (
  filtersStore.filters.patientAge !== undefined
    ? `${t('Возраст пациента', options.value)}: ${filtersStore.filters.patientAge}`
    : t('Возраст пациента', options.value)
))

watch(
  () => filtersStore.filters.patientAge,
  () => {
    chipsStore.updatePatientAgeChip({
      name: patientAgeLabel.value,
      isActive: filtersStore.filters.patientAge !== undefined,
      dropdown: filtersStore.filters.patientAge === undefined,
      isVisible: true,
      onClick: openDialog,
      async onReset() {
        filtersStore.updateFilters({ patientAge: undefined })

        await updateDoctorListPage()

        dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
          upper: true,
          message: t('Фильтр сброшен', options.value),
        })
      },
    })
  },
  { immediate: true },
)

const applyFilter = async () => {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  await updateDoctorListPage()
}

const handleSubmit = () => {
  if (isActiveButton.value) {
    applyFilter()
  }
}

// Делаем задержку такую же как в дочернем компоненте, чтобы дочерний компонент не затёр данные по таймауту
const debouncedHandleInput = debounce(() => {
  filtersStore.resetUnsavedFilters()
}, 500)

const handleInput = () => {
  debouncedHandleInput()
}
</script>
